import styled from 'styled-components';
import { Link } from 'react-router-dom';

const InternalLink = styled(Link)<{ $disabled?: boolean }>`
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.palette.content.disabled : theme.palette.accent.primary};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

export default InternalLink;
